<template lang="pug">
div
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent)
    v-card
      v-card-title.py-4.px-5
        div.h6.basic800--text {{ $t('sales_page') }}
      v-divider.basic300
      v-card-text.py-4.px-5
        div.p1.primary--text {{ $t('sales_page_desc') }}
        v-row.mt-6(no-gutters align="center")
          v-col.pr-4.shrink
            eva-icon(name="edit-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="22" height="22" style="margin-top: 3px")
          v-col
            div.c1.basic600--text {{ $t('sales_page_text_1') }}
        v-row.mt-1(no-gutters align="center")
          v-col.pr-4.shrink
            eva-icon(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="22" height="22" style="margin-top: 4px")
          v-col
            div.c1.basic600--text {{ $t('sales_page_text_2') }}
        v-row.mt-1(no-gutters align="center")
          v-col.pr-4.shrink
            eva-icon(name="credit-card-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="22" height="22" style="margin-top: 5px")
          v-col
            div.c1.basic600--text {{ $t('sales_page_text_3') }}
        v-card.basic200.pa-4.elevation-0.mt-4
          v-layout.pa-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          template(v-else)
            div.f2.danger400--text.text-right {{ $t('get_your_discount') }}
            div.d-flex.align-center(v-if="prices")
              div.s1.primary--text {{ $t('sales_page') }}
              v-spacer
              div.c2.textColorHint--text.text-decoration-line-through(v-if="slashPrices") {{ slashPrices[$currency.code] | displayPrice($currency) }}
              div.s1.success500--text.ml-1 {{ prices[$currency.code] | displayPrice($currency) }}
            div.c1.textColorHint--text.text-right {{ $t('monthly') }}
            v-divider.basic400.my-4
            ul
              li.c1.basic600--text {{ $t('page_feature_1') }}
              li.c1.basic600--text {{ $t('page_feature_2') }}
              li.c1.basic600--text {{ $t('page_feature_3') }}

            v-btn.button-AA-small.mt-5(block dark color="info500" small height="32" depressed :loading="isLoading" @click="openConfirmationDialog = true") {{ $t('subscribe_now') }}
            v-btn.mt-1(color='transparent' text @click='showModal = false' block)
              .button-Aa-small.primary400--text {{ $t('cancel') }}

      .modal
        y-dialog(v-if="openConfirmationDialog" v-model='openConfirmationDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('subscribe_sales_page') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('subscribe_sales_page_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click="openConfirmationDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='info500' depressed height=32 @click="subscribeSalesPage" dark :loading="isLoading")
                .button-AA-small.basic100--text {{ $t('confirm') }}

        y-dialog(v-if="openSuccessDialog" v-model='openSuccessDialog', max-width='270')
          v-card.pa-4.text-center
            div.p1.primary500--text {{ message }}
            v-btn.mt-3(color='transparent', text @click='closeDialog' block x-small)
              .button-Aa-small.primary400--text {{ $t('close') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SalesPageSubscription',
  props: ['open', 'company'],
  data: () => ({
    openSuccessDialog: false,
    openConfirmationDialog: false,
    isLoading: false,
    isFetching: false,
    cards: [],
    message: '',
    prices: null,
    slashPrices: null
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    primaryCard () {
      if (this.cards.length === 0) {
        return null
      } else if (this.cards.length === 1) {
        return this.cards[0]
      } else {
        return this.cards.filter(c => c.primary)[0]
      }
    }
  },
  watch: {
  },
  mounted () {
    this.fetchPlanPrice()
    this.fetchCards()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCards () {
      this.$axios.get('/billing/cards/')
        .then(resp => {
          this.cards = resp.data.results
        })
        .catch(() => {})
    },
    fetchPlanPrice () {
      this.isFetching = true
      this.$axios.get(`/subscription/plans/YZ_LANDING_PAGE_PLAN`)
        .then(resp => {
          let plan = resp.data.contracts.find(f => f.code === 'YZ_LANDING_PAGE_PLAN_MM')
          if (plan) {
            this.prices = plan.prices
            this.slashPrices = plan.compare_at_prices
            this.isFetching = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    subscribeSalesPage () {
      this.isLoading = true
      let data = {
        company: this.company.id,
        contract: 'YZ_LANDING_PAGE_PLAN_MM',
        card: this.primaryCard ? this.primaryCard.id : null,
        terminate_existing: true
      }
      this.$axios.post(`/subscription/subscriptions/`, data)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/charge_card/`, data)
            .then(() => {
              this.message = 'Subscription successful'
              this.openSuccessDialog = true
            })
            .catch(() => {
              this.message = 'Subscription successful. Please complete the payment to avoid termination.'
              this.openSuccessDialog = true
            })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
          this.isLoading = false
        })
    },
    closeDialog () {
      this.openSuccessDialog = false
      this.showModal = false
      window.location.reload()
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "subscribe_sales_page": "Subscribe sales page",
    "subscribe_sales_page_confirmation": "Are you sure you want to subscribe sales page?",
    "sales_page_desc": "Custom your landing page with headline, copywriting & images",
    "sales_page_text_1": "Edit font type, size & colour",
    "sales_page_text_2": "Manage shipments with 2-clicks",
    "sales_page_text_3": "Accept payment from 17+ major banks",
    "monthly": "monthly",
    "page_feature_1": "3 sales pages",
    "page_feature_2": "Unlimited product",
    "page_feature_3": "Unlimited storage",
    "get_your_discount": "Get your discount now!"
  },
  "id": {
    "subscribe_sales_page": "Langganan sales page",
    "subscribe_sales_page_confirmation": "Anda yakin ingin berlangganan?",
    "sales_page_desc": "Kustomisasi halaman penjualan kamu dengan judul, copywriting & gambar",
    "sales_page_text_1": "Edit jenis font, ukuran & warna",
    "sales_page_text_2": "Kelola pengiriman dengan 2 klik",
    "sales_page_text_3": "Terima pembayaran dari 17+ bank besar",
    "monthly": "bulanan",
    "page_feature_1": "3 halaman penjualan",
    "page_feature_2": "Produk tidak berbatas",
    "page_feature_3": "Penyimpanan tidak berbatas",
    "get_your_discount": "Dapatkan diskon kamu sekarang!"
  }
}
</i18n>
